module.exports = __webpack_public_path__ + "img/nav-design-classic@2x.7db870e.jpg";